import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@shared/state/AuthContext'
import { returnsAfterSignIn } from '../routes'

/**
 * Route guard for the standalone website.
 *
 * This keeps the interface behind a sign-in. It is not access control: the
 * files themselves are still served by the dev server. Real protection arrives
 * with Supabase row level security and signed Storage URLs.
 */
export function RequireAuth() {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    // Brief, and deliberately blank — a spinner here flashes on every load.
    return <div className="auth-gate" />
  }

  if (!session) {
    // Signing in always lands on the overview, with one exception: Connect
    // Miro has a job to finish, and what it needs is in its address (routes.ts).
    const from = returnsAfterSignIn(location.pathname)
      ? location.pathname + location.search
      : undefined
    return <Navigate to="/login" replace state={from ? { from } : undefined} />
  }

  return <Outlet />
}
